import CONFIG from '../../globals/config'

const RestaurantItemTemplate = (restaurant) => `
  <div class="restaurant-item">
    <a href="/#/detail/${restaurant.id}">
      <img
        class="lazyload restaurant-item__image"
        alt="${restaurant.name}"
        data-src="${restaurant.pictureId ? CONFIG.BASE_IMAGE_SMALL_URL + restaurant.pictureId : 'https://picsum.photos/id/666/800/450?grayscale'}"
      >
      <div class="restaurant-item__name">
        ${restaurant.name}
      </div>
      <div class="restaurant-item__rating">
        ${restaurant.city}
        <i class="fa fa-star" aria-hidden="true"></i> ${restaurant.rating}
      </div>
    </a>
  </div>
`

export default RestaurantItemTemplate
